<template>
    <div v-if="visible">
        <el-drawer title="搜索文章" :visible.sync="visible"  :direction="direction" :before-close="handleClose" size="93%">
            <div class="drawer-body">
                <VisualDatePicker @date-selected="handleDateSelection" @search="search(true)" />

                <div class="dialog-header">
                    <div class="input-wrapper">
                        <input
                        class="dialog-header-input"
                        v-model="searchQuery"
                        @focus="onFocus"
                        @blur="hideSuggest"
                        @input="filterSuggest"
                        placeholder="输入关键词以搜索,多个关键词需用英文逗号隔开"
                        />
                        <div v-if="showSuggest && filteredList.length" class="suggest-panel">
                            <div v-for="(item, index) in filteredList" :key="index" class="suggest-item"  @mousedown.prevent="chooseSuggest(item)" >
                                {{ item }}
                            </div>
                        </div>
                    </div>

                    <button class="search-btn" @click="search(true)">
                        <i class="el-icon-search"></i>
                    </button>
                </div>

                <div class="dialog-body">
                    <div v-for="(item, index) in dataList" :key="index" @click="goToArticle(item)" class="dialog-body-container">
                        <span class="dialog-body-container-index">{{index + 1 + (page -1) * 20}}</span>
                        <!-- <span style="width: 5%;">
                            <i class="el-icon-document"></i>
                        </span> -->
                        <div style="width: 86%;">
                            <div class="dialog-body-container-title" v-html="item.highlightedTitle"></div>
                            <div class="dialog-body-container-text" v-html="item.highlightedContent"></div>
                        </div>
                        <span style="width: 5%;margin-left: 3%;">
                            <i class="el-icon-back" style="color: white;"></i>
                        </span>
                    </div>
                    <p v-if="dataList.length < 1" style="margin: 2rem auto;color: #909399;font-weight: 300;font-size: 1.21rem;">暂无搜索结果 ～～</p>
                </div>

                <div class="dialog-footer">
                    <div v-if="total > 1" style="display: flex; align-items: center;">
                        <button class="page-btn" @click="prevPage" :disabled="page === 1">上一页</button>
                        <span style="margin: 0 .5rem;">{{ page }} / {{ Math.ceil(total / size) }}</span>
                        <button class="page-btn" @click="nextPage" :disabled="page >= Math.ceil(total / size)">下一页</button>
                    </div>
                    <span style="display: flex;align-items: center;">
                        <svg t="1742527369835" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="104862" width="22" height="22"><path d="M616 64H408c-119.3 0-216 96.71-216 216v360c0 176.73 143.27 320 320 320s320-143.27 320-320V280c0-119.29-96.71-216-216-216z m168 576a272 272 0 1 1-544 0V280a168 168 0 0 1 168-168h92v113.3a56 56 0 0 0-44 54.7v80a56 56 0 0 0 112 0v-80a56 56 0 0 0-44-54.7V112h92a168 168 0 0 1 168 168zM512 238a42 42 0 0 1 42 42v80a42 42 0 0 1-84 0v-80a42 42 0 0 1 42-42z" fill="" p-id="104863"></path></svg>
                        请使用鼠标上下滑动查看
                    </span>
                    <span> 关键词命中：{{ total }} 条</span>
                </div>
 
            </div>
        </el-drawer>
    </div>
</template>

<script>
import VisualDatePicker from './DatePicker.vue';
import searchApi from '@/api/searchApi';
import getDeviceInfo from '@/utils/deviceInfo';

export default {
    components: {
        VisualDatePicker
    },
    props: {
        visible: Boolean,
    },
    data() {
        return {
            direction: "ttb",
            searchQuery: "",
            showSuggest: false,
            suggestList: JSON.parse(localStorage.getItem("history")) || [],
            filteredList: [],
            dataList: [],
            page: 1,
            size: 20,
            total: 0,
            startDate: null,
            endDate: null,
            nowSearchRecordId: null,
        }
    },
    methods: {
        async goToArticle(item) {
            if (!this.nowSearchRecordId) return; // 如果没有记录ID，直接返回

            try {
                const dataForm = {
                    articleId: item.id
                }
                const res = await searchApi.clickArticle(this.nowSearchRecordId, dataForm);

                if (res.code === 200) {

                    window.open(
                        this.$router.resolve({
                            path: '/article',
                            query: { key: item.metadataName }
                        }).href,
                        '_blank'
                    )

                    // await this.closeDialog()
                } else {
                    console.error('点击文章失败:', res.message || '未知错误')
                    // 可选：提示用户
                    // this.$message.error(res.message || '加载文章失败，请重试');
                }
            } catch (error) {
                console.error('请求过程中发生错误:', error)
                // 可选：提示用户
                // this.$message.error('网络异常，请检查连接后重试');
            }
        },
        onFocus() {
            this.showSuggest = true
            this.filterSuggest() // 关键：聚焦时也要过滤一次，哪怕输入框是空的
        },
        filterSuggest() {
            const q = this.searchQuery.toLowerCase()
            const list = []
            this.suggestList.forEach(element => {
                list.push(element.query)
            })
            if(this.suggestList.length > 0) {
                this.filteredList = list.filter(item =>
                    item.toLowerCase().includes(q)
                )
            }
        },
        chooseSuggest(item) {
            this.searchQuery = item
            this.search(true)
            this.showSuggest = false
        },
        hideSuggest() {
            // 延迟隐藏，避免点击选项时输入框 blur 导致立刻消失
            setTimeout(() => {
                this.showSuggest = false
            }, 200)
        },
        async search(resetPage = false) {
            if (resetPage) this.page = 1

            const deviceInfo = JSON.stringify(getDeviceInfo())
            const query = {
                query: this.searchQuery,
                page: this.page,
                pageSize: this.size,
                startDate: this.startDate, // 格式如 "2024-01-01"
                endDate: this.endDate,      // 格式如 "2024-12-31"
                uaInformation: deviceInfo
            }
            searchApi.search(query).then(res => {
                this.nowSearchRecordId = res.data.recordId
                this.dataList = res.data.result.hits.map(item => {
                    return {
                        ...item,
                        highlightedTitle: item._formatted.title
                        .replace(/<em>/g, '<span style="color:green; font-weight:bold">')
                        .replace(/<\/em>/g, '</span>'),
                        highlightedContent: item._formatted.content
                        .replace(/<em>/g, '<span style="color:green; font-weight:bold">')
                        .replace(/<\/em>/g, '</span>')
                    }
                })
                if(res.data.result.offset && res.data.result.offset  > 0) {
                    this.page = res.data.result.offset/res.data.result.limit + 1
                } else {
                    this.page = 1
                }
                this.size = res.data.result.limit
                this.total = res.data.result.estimatedTotalHits
                // 保存历史
                if (query.query) {
                    query.hits = this.total
                    query.searchTime = new Date().getTime()

                    // 找到已存在的索引
                    const existIndex = this.suggestList.findIndex(item => item.query === query.query)

                    if (existIndex !== -1) {
                        // 删除旧位置的元素
                        this.suggestList.splice(existIndex, 1)
                    }
                    // 插到 suggestList 开头
                    this.suggestList.unshift(query)
                    // 只保留最近 15 条
                    if (this.suggestList.length > 15) {
                        this.suggestList = this.suggestList.slice(0, 15)
                    }
                    localStorage.setItem('history', JSON.stringify(this.suggestList))
                }
            })
        },
        handleClose(done) {
            this.startDate = ''
            this.endDate = ''
            this.dataList= [],
            this.page= 1,
            this.size= 20,
            this.total= 0,
            this.$emit("update:visible", false)
        },

        handleDateSelection(range) {
            console.log('选择的日期范围:', range)
            this.startDate =  range.start
            this.endDate =  range.end
            // 执行数据筛选等操作
        },

        prevPage() {
            if (this.page > 1) {
                this.page--
                this.search()
            }
        },
        nextPage() {
            if (this.page < (this.total / this.size)) {
                this.page++
                this.search()
            }
        },
    }
}
</script>

<style scoped lang="scss">
.drawer-body {
    padding: .8rem;
    padding-bottom: 2rem;
}

.dialog-header {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.dialog-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.suggest-item {
    padding: 8px 12px;
    cursor: pointer;
    border-radius: .2rem .5rem .5rem .2rem;
}

.suggest-item:hover {
    background: #74c8a3;
    color: #fff;
}

.input-wrapper {
    position: relative; /* 关键：让 suggest-panel 以它为定位参考 */
    width: 70%;
    max-width: 720px;
}

.dialog-header-input {
    width: 100%;
    padding: .8rem;
    padding-left: .8rem;
    border: none;
    border-bottom: .1rem #b4b4b4 solid;
    font-size: 1rem;
    margin: 1rem 0;
}

.suggest-panel {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%; /* 跟 input 一样宽 */
    background: #fff;
    border: 1px solid #eee;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    max-height: 68vh;
    overflow-y: auto;
    z-index: 99;
    padding: .5rem;
    border-radius: .2rem;
}

.dialog-header-input:focus {
    border: none;
    border-bottom: .1rem #74c8a3 solid; /* 保持一致 */
    outline: none; /* 再次确保不出现蓝框 */
}

.search-btn {
    margin-left: 2.2rem;
    padding: .6rem;
    font-size: 1.5rem;
    background: #74c8a3;
    color: white;
    border: none;
    border-radius: .2rem .3rem .3rem .2rem;
    cursor: pointer;
}

.dialog-body {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    /* border-top: #88ba96 solid .05rem; */
    margin-top: 1rem;
    background: #f9fafc;
    height: 100%;
    min-height: 34vh;
    max-height: 67vh;
    overflow: scroll;
    padding: 1rem;
    box-sizing: border-box;
}

/* 滚动条整体 */
.dialog-body::-webkit-scrollbar {
    width: 4px; /* 垂直滚动条宽度 */
    height: 0px; /* 水平滚动条高度 */
}

/* 滚动条滑块 */
.dialog-body::-webkit-scrollbar-thumb {
    background-color: #74c8a3;
    border-radius: 4px;
}

/* 滚动条轨道 */
.dialog-body::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
}

.dialog-body-container-title {
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 1;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    margin-bottom: .2rem;
    margin-top: 0;
    font-weight: 500;
    font-size: 1.28rem;
}

.dialog-body-container-text {
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 4;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2.8rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    margin-bottom: .2rem;
    margin-top: 0;
    font-size: .97rem;
    font-weight: 300;
    color: #909090;
}

.dialog-body-container-index {
   width: 6%;
   color: green;
   font-weight: 700;
   font-size: 1.2rem;
   text-align: center;
}

.page-btn {
    color: white;
    background: #74c8a3;
    border: none;
    border-radius: .22rem;
    padding: .2rem .5rem;
}

.dialog-body-container {
    width: 100%;
    padding: .5rem;
    background: white;
    border-radius: .5rem;
    min-height: 5.6rem;
    max-height: 6.2rem;
    max-width: 1268px;
    display: flex;
    align-items: center;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 四边均衡阴影 */
    margin: .5rem 0;
    cursor: pointer;
}

.dialog-body-container:hover {
    background: #74c8a3;
    color: white;

    .dialog-body-container-text {
        color: white;
    }

    .dialog-body-container-index {
        color: white;
    }
}

.dialog-footer {
    position: absolute;
    bottom: 0;
    right: 1rem;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 1rem;
    background: white;
    width: calc(100% - 2rem);
    box-sizing: border-box;
    padding: .5rem;
}
</style>